import { cn } from '@/modules/shared/lib/utils';
import { Pointer } from 'lucide-react';
import React from 'react';
import { FaHandPointer } from 'react-icons/fa';

export const PromotionBadge = ({
	valorPromocao,
	flagPromocao,
	canActivatePromotion,
	onActivatePromotion,
	onDisablePromotion,
	qtdPromocao,
	formattedPromotionValue,
	formattedPromotionValueWithDiscount,
	product,
	toast,
	showMinQuantity,
}) => {
	const handleClick = () => {
		if (canActivatePromotion()) {
			flagPromocao ? onDisablePromotion() : onActivatePromotion();
		} else {
			toast.info(`Quantidade mínima para promoção: ${qtdPromocao}`);
		}
	};

	const handleKeyUp = (e) => {
		if (e.key === 'Enter' && canActivatePromotion()) {
			flagPromocao ? onDisablePromotion() : onActivatePromotion();
		}
	};

	if (valorPromocao <= 0) return null;

	return (
		<div className="absolute top-0 left-0 z-0">
			<div
				onClick={handleClick}
				onKeyUp={handleKeyUp}
				className={cn(
					"relative cursor-pointer transition-all duration-300",
					!canActivatePromotion() && "cursor-not-allowed"
				)}
			>
				<div className={cn(
					"relative rounded-tl-md",
					product.quantidade > 0 && flagPromocao
						? "bg-green-600"
						: "bg-amber-500",
					"rounded-br-2xl overflow-hidden",
					canActivatePromotion() && "transform hover:scale-105"
				)}>
					<div className="px-3 py-1">
						<div className="flex items-center gap-1.5 text-white">
							<span className="text-xs animate-pulse">🔥</span>
							<span className="text-[10px] font-bold tracking-wide">PROMOÇÃO</span>


						</div>

						<div className="mt-1 space-y-0.5">
							{qtdPromocao > 0 && showMinQuantity && (
								<p className="text-[10px] text-white/90 font-medium">
									A partir de
								</p>
							)}

							<p className="text-[0.9rem] font-extrabold text-white leading-none">
								{qtdPromocao > 0
									? `${qtdPromocao} Un - R$ ${formattedPromotionValueWithDiscount}`
									: `R$ ${formattedPromotionValueWithDiscount}`}

							</p>
							{/* {qtdPromocao > 0 && (
								<p className="text-[0.8rem] font-extrabold text-white leading-none">
									R$ ${formattedPromotionValueWithDiscount}
								</p>
							)} */}

						</div>
					</div>

					<div className="absolute -bottom-0.5 -right-0.5 w-6 h-6 bg-white/10 rounded-tl-full" />
				</div>

			</div>
		</div>
	);
};
